import { MDBFooter } from 'mdb-react-ui-kit';
import down from "./../assets/svg/down.svg";
import footer_about from "./../assets/svg/footer_about.svg";
import footer_contact from "./../assets/svg/footer_contact.svg";
import footer_home from "./../assets/svg/footer_home.svg";
import git from "./../assets/svg/github-svgrepo-com.svg";
import instagram from "./../assets/svg/instagram-svgrepo-com.svg";
import linkedin from "./../assets/svg/linkedin-svgrepo-com.svg";
import telegram from "./../assets/svg/telegram-svgrepo-com.svg";
import upworksvgrepocom from "./../assets/svg/upwork-svgrepo-com.svg";
import './../styles/footer.css';

export default function Footer() {
    return (
        
        <MDBFooter className='text-center text-lg-left'>
            
            <div className="d-flex justify-content-center position-relative footer-block">
                <a href="#home_id">
                    <img src={footer_home} className='about-images'></img>
                </a>
                <a href="#about_id">
                    <img src={footer_about} className='about-images'></img>
                </a>
                <a href="#contact_id">
                    <img src={footer_contact} className='about-images'></img>
                </a>
                <div className='top-button '>
                <a href="#home_id"><img src={down} alt="" /></a>
            </div>
            </div>
            <div className="d-flex justify-content-center">
                <a target="_blank" href="https://github.com/My-CD-ROM">
                    <div className='footer-social-div'>
                        <img src={git} className='footer-social-icon'></img>
                    </div>
                </a>
                <a target="_blank" href="https://www.upwork.com/freelancers/~01aafb24e683572890">
                    <div className='footer-social-div'>
                        <img src={upworksvgrepocom} className='footer-social-icon'></img>
                    </div>
                </a>
                <a target="_blank" href="https://www.linkedin.com/in/roman-boba-255920187/?locale=en_US">
                    <div className='footer-social-div'>
                        <img src={linkedin} className='footer-social-icon'></img>
                    </div>
                </a>
                <a target="_blank" href="https://t.me/RomanBoba">
                    <div className='footer-social-div'>
                        <img src={telegram} className='footer-social-icon'></img>
                    </div>
                </a>
                <a target="_blank" href="https://www.instagram.com/romario1_1/">
                    <div className='footer-social-div'>
                        <img src={instagram} className='footer-social-icon'></img>
                    </div>
                </a>
            </div>
            <div className='text-center p-3'>
                &copy; {new Date().getFullYear()}{' '}
                <a className='text-light' href='https://romanboba.com/'>
                    romanboba.com
                </a>
            </div>
        </MDBFooter>
    );
}